import React, { useState } from "react";
import T from "prop-types";
import _, { get } from "lodash";
import api from "APP_ROOT/api";
import { miniTable, translateProps } from "MODULES/shared/decorators";
import { dollars } from "LIB/formatters/currency";
import { Link } from "react-router-dom";
import {
  ImprovedDropDown as DropDown,
  ImprovedDropDownItem as DropDownItem
} from "MODULES/shared/components/DropDown";
import ReturnRepairItem from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/ReturnRepairItem/ReturnRepairItem";
import ReturnRepairItemModal from "MODULES/RepairOrders/components/Detail/LineItems/LineItemControls/ReturnRepairItem/ReturnRepairItemModal";
import CoreReturnCostSavingsModal from "./LineItemControls/CoreReturnCostSavings/CoreReturnCostSavingsModal";
import { Table } from "./Table";

export const allowEditing = ({ exchange, shipped, finalEval }) =>
  exchange && shipped && !finalEval;

function LineItemControls({ lineItem }) {
  if (!lineItem.repaired_line_item) return null;

  const {
    repaired_line_item: { exchange, final_evaluation_approved: finalEval },
    shipped
  } = lineItem;

  const [returnItemModal, setReturnItemModal] = useState(null);

  const toggleReturnModal = () =>
    returnItemModal === lineItem.id
      ? setReturnItemModal(null)
      : setReturnItemModal(lineItem.id);

  if (allowEditing({ exchange, shipped, finalEval })) {
    return (
      <div>
        <DropDown>
          <DropDownItem
            label="Core Return Cost Savings"
            id="core-return-cost-savings"
            faIcon="dollar"
            renderActive={<CoreReturnCostSavingsModal lineItem={lineItem} />}
          />
          <ReturnRepairItem
            toggleReturnModal={toggleReturnModal}
            lineItem={lineItem}
          />
          <ReturnRepairItemModal
            lineItem={lineItem}
            open={returnItemModal === lineItem.id}
            close={toggleReturnModal}
          />
        </DropDown>
      </div>
    );
  }

  return null;
}

export const ShopAssistColumns = {
  "Orig PP Cost From Eval": ({ lineItem }) =>
    dollars(get(lineItem, "original_piece_part_cost")),
  "Final PP Cost": ({ lineItem }) =>
    dollars(get(lineItem, "final_piece_part_cost")),
  "Core Return Cost Savings": ({ lineItem }) =>
    dollars(get(lineItem, "core_return_cost_savings")),
  "": ({ lineItem }) => {
    if (lineItem.shipped) {
      const [returnItemModal, setReturnItemModal] = useState(null);

      const toggleReturnModal = () =>
        returnItemModal === lineItem.id
          ? setReturnItemModal(null)
          : setReturnItemModal(lineItem.id);
      return (
        <DropDown>
          <ReturnRepairItem
            toggleReturnModal={toggleReturnModal}
            lineItem={lineItem}
          />
          <ReturnRepairItemModal
            lineItem={lineItem}
            open={returnItemModal === lineItem.id}
            close={toggleReturnModal}
          />
        </DropDown>
      );
    }

    return null;
  }
};

LineItemControls.propTypes = {
  lineItem: T.shape({
    exchange: T.bool,
    final_evaluation_approved: T.bool
  })
};

class ShopAssistTable extends React.Component {
  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    if (this.mounted && this.props.partCosts !== nextProps.partCosts) {
      this.props.reload();
    }
  }

  render() {
    const { results, loading } = this.props;

    if (!results || results.length === 0) {
      return null;
    }

    return (
      <React.Fragment>
        <h2 style={{ marginTop: 26 }}>Shop Assist Parts</h2>
        {!loading && (
          <Table
            results={results}
            disabled
            startColumns={{
              "RO #": ({ lineItem }) => (
                <Link to={`/repair-orders/${lineItem.repair_order_id}`}>
                  {lineItem.repair_order_code}
                </Link>
              ),
              "Orig. PN/SN": ({ lineItem }) => (
                <Link
                  to={`/inventories/${_.get(
                    lineItem,
                    "repaired_line_item.inventory_id"
                  )}`}
                >
                  {_.get(lineItem, "repaired_line_item.part.part_number")} /{" "}
                  {_.get(lineItem, "repaired_line_item.serial_number")}
                </Link>
              )
            }}
            endColumns={{
              ...ShopAssistColumns,
              " ": ({ lineItem }) => <LineItemControls lineItem={lineItem} />
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

const withProps = translateProps(({ repairOrder }) => ({
  ids: repairOrder.get("line_items").map(l => l.get("id")),
  partCosts: repairOrder.get("line_items").map(l => l.part_cost)
}));

const withResults = miniTable(
  ({ ids }, params) =>
    api.repairOrders.lineItems.shopAssistItems(Object.assign(params, { ids })),
  50
);

export default withProps(withResults(ShopAssistTable));

ShopAssistTable.propTypes = {
  reload: T.func.isRequired,
  results: T.instanceOf(Array),
  loading: T.bool.isRequired,
  lineItem: T.shape({}),
  partCosts: T.arrayOf(T.number)
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/ShopAssistTable.jsx